module.exports = __webpack_public_path__ + "static/construction-dumpster-banner-9ec7aa7628f8be1e7b0a9ccf92d9fd33.jpg";